import React, { useState } from 'react';
// The webpack 5 entry sets GlobalWorkerOptions.workerSrc to react-pdf's OWN pdfjs-dist worker through
// new URL(..., import.meta.url), so the build emits the worker as a static asset the app serves itself
// (same origin, same pdf.js version as the API). The previous cdnjs URL failed wherever the browser could
// not reach the CDN (offline, proxy, blockers) and shipped a third-party script into a document viewer.
// NOTE: the top-level pdfjs-dist (3.x, pulled in by kendo-react-pdf-viewer) is a different version from
// react-pdf's nested copy (2.16); the worker MUST come from react-pdf's copy, which this entry guarantees.
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack5';
import { isMobileOnly, usePosition} from './AccentDisplay';
import { ProgressBar } from './AccentSpinner';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';

let currentZoom = 1500;

export const AccentPdfViewer = ({ document, height, onLoaded }) => {
    const [numPages, setNumPages] = useState(null);
    const [width, setWidth] = useState(isMobileOnly ? window.innerWidth - 50 : currentZoom); 

    const pos = usePosition("acc-pdf-viewer");

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);

        if (onLoaded) onLoaded();
    };

    const handleWidthChange = (event) => {
        const newWidth = parseInt(event.target.value);
        setWidth(newWidth);
        currentZoom = newWidth;
    };


    React.useEffect(() => {
        setNumPages(null);
    }, [document, setNumPages]);

    // react-pdf 6.2's findDocumentSource has no return on its string branch, so a bare url string makes it throw (and
    // swallow) an invariant before resolving - harmless, but it trips "break on all exceptions" in the debugger on
    // every render. The { url } object form takes the branch that returns, and is memoized so <Document> does not
    // see a new file identity each render. Anything that is not a string is passed through as is.
    const file = React.useMemo(() => (typeof document === 'string' ? { url: document } : document), [document]);


    return (
        <div id="acc-pdf-viewer"
            style={{
                minHeight: `${height}px`
            }}
        >
            {!pos.positionKnown && <ProgressBar />}
            {pos.positionKnown && <div
                style={{
                    width: "100%"
                }}
            >
                
                {!isMobileOnly && <div style={{ margin: '10px 0', width: "100%" }} >
                    <input
                        style={{ width: "100%" }}
                        type="range"
                        min="500"
                        max={pos.toScreenWidth - 50}
                        value={width}
                        onChange={handleWidthChange}
                        placeholder="Zoom"
                    />
                </div>}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Document
                        key={document}
                        file={file}
                        onLoadSuccess={onDocumentLoadSuccess}
                        loading={<ProgressBar />}
                >
                    {Array.from(new Array(numPages), (el, index) => (
                        <div style={{ border: '1px solid black', margin: '10px' }} key={`page_container_${index + 1}`}>
                            <Page key={`page_${index + 1}`} pageNumber={index + 1} width={width} renderTextLayer={false} />
                        </div>
                    ))}
                </Document>
                </div>
            </div>
            }
        </div>
    );
};


